/**
 * User: nir
 * Date: 01/11/2016
 * Time: 14:06
 */

if (window.jQuery) {
    window.jQuery(function ($) {
        if (!window['jwplayer'] || !$('main').is('.article[data-type=video]')) return;

        var player = window['jwplayer']();
        if (!player) return;

        // bind event handlers
        player.on('playlistItem', function setVideoTargeting(data) {
            if (!data || !data.item) return;

            if (TCT && TCT.JWPlayer) {
                TCT.JWPlayer.setTargetingParams(data.item);
            }
        });
    });
}